import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Toolbar } from '@mui/material';

export const HomeLink = styled(Link)`
  display: block;
  padding: 5px 10px 0 10px;
`;

export const HomeLogo = styled.img`
  max-width: 100%;
  width: 160px;
  justify-content: center;
`;

export const SmallScreenToolbar = styled(Toolbar)`
  padding: 0 10px;
`;
